export const TOAST_IDS = {
  STUDENT: {
    THERE_IS_ALREADY_AN_REQUEST_IN_ANALYSIS:
      'THERE_IS_ALREADY_AN_REQUEST_IN_ANALYSIS'
  },
  MANAGER: {
    INVALID_FIELDS_IN_GRANT_REVIEW: 'INVALID_FIELDS_IN_GRANT_REVIEW'
  },
  COMMON: {
    BLOCKED_ENROLLMENT_PERIOD: 'BLOCKED_ENROLLMENT_PERIOD',
    REQUEST_STEP_FAILED: 'REQUEST_STEP_FAILED'
  }
}
